import type { AddCategorySopSection } from "../types";

export const ADD_CATEGORY_SOP_SECTIONS: AddCategorySopSection[] = [
  {
    id: "before-you-start",
    titleKey: "add-category-sop-before-start-title",
    titleFallback: "Before you start",
    steps: [
      {
        bodyKey: "add-category-sop-before-start-1",
        bodyFallback:
          "A category is a group name for your products. Examples: Electronics, Food, Beverages, or Cleaning supplies."
      },
      {
        bodyKey: "add-category-sop-before-start-2",
        bodyFallback:
          "Create your categories before adding products. This keeps your shop organised and makes it easier for staff to find items."
      },
      {
        bodyKey: "add-category-sop-before-start-3",
        bodyFallback:
          "You can create main categories and smaller groups inside them. For example, Food can contain Snack, and Snack can contain Biscuits."
      }
    ]
  },
  {
    id: "open-categories-page",
    titleKey: "add-category-sop-open-page-title",
    titleFallback: "Open the Categories page",
    steps: [
      {
        bodyKey: "add-category-sop-open-page-1",
        bodyFallback: "Sign in to Kivunova FMS with your company account."
      },
      {
        bodyKey: "add-category-sop-open-page-2",
        bodyFallback: "On the left menu, open Inventory, then tap Categories."
      },
      {
        bodyKey: "add-category-sop-open-page-3",
        bodyFallback:
          "You will see the category list. Each row shows the category name, how many products are in it, and whether it is active.",
        imageId: "categories-page"
      }
    ]
  },
  {
    id: "start-new-category",
    titleKey: "add-category-sop-start-title",
    titleFallback: "Start a new category",
    steps: [
      {
        bodyKey: "add-category-sop-start-1",
        bodyFallback:
          "On the Categories page, click the purple Add New Category button at the top right of the list."
      },
      {
        bodyKey: "add-category-sop-start-2",
        bodyFallback:
          "A window will open where you can enter the details for the new category.",
        imageId: "new-category-modal"
      }
    ]
  },
  {
    id: "name-and-describe",
    titleKey: "add-category-sop-name-title",
    titleFallback: "Name and describe the category",
    steps: [
      {
        bodyKey: "add-category-sop-name-1",
        bodyFallback:
          "Enter a Category Name your team will recognise. Keep it short and clear. Examples: Food, Beverages, or Phones."
      },
      {
        bodyKey: "add-category-sop-name-2",
        bodyFallback:
          "Add a Description if helpful. This is optional. Use it to note what types of products belong in this group."
      },
      {
        bodyKey: "add-category-sop-name-3",
        bodyFallback:
          "Required fields are marked with *. Fill those in before saving."
      }
    ]
  },
  {
    id: "category-structure",
    titleKey: "add-category-sop-structure-title",
    titleFallback: "Understand parent and child categories",
    steps: [
      {
        bodyKey: "add-category-sop-structure-1",
        bodyFallback:
          "A parent category is the larger group. Child categories sit underneath and narrow the group — for example Paint → Water-Based Paint → Interior Water-Based Paint → Wall Paint."
      },
      {
        bodyKey: "add-category-sop-structure-2",
        bodyFallback:
          "Build several levels when it helps your team browse. Use leaf categories (the deepest level) for where products are usually assigned."
      },
      {
        bodyKey: "add-category-sop-structure-3",
        bodyFallback:
          "See Learn more → Categories and subcategories for a full paint-shop tree, product-form mapping, and a worked example product path."
      }
    ]
  },
  {
    id: "parent-category",
    titleKey: "add-category-sop-parent-title",
    titleFallback: "Choose a parent category (optional)",
    steps: [
      {
        bodyKey: "add-category-sop-parent-1",
        bodyFallback:
          "Use Parent Category when you want this group to sit inside a larger one."
      },
      {
        bodyKey: "add-category-sop-parent-2",
        bodyFallback:
          "Pick None (top-level category) when you are creating a main heading, such as Electronics or Food.",
        imageId: "parent-category"
      },
      {
        bodyKey: "add-category-sop-parent-3",
        bodyFallback:
          "Pick an existing category when you are creating a subcategory. For example, put Phones under Electronics, or Biscuits under Snack."
      },
      {
        bodyKey: "add-category-sop-parent-4",
        bodyFallback:
          "You can build several levels. A main category can hold subcategories, and those can hold smaller groups too."
      }
    ]
  },
  {
    id: "save-and-review",
    titleKey: "add-category-sop-save-title",
    titleFallback: "Save and review your list",
    steps: [
      {
        bodyKey: "add-category-sop-save-1",
        bodyFallback:
          "When the details look correct, click the save button at the bottom of the window to add the category."
      },
      {
        bodyKey: "add-category-sop-save-2",
        bodyFallback:
          "The new category appears in your list. Active categories show a green Active badge."
      },
      {
        bodyKey: "add-category-sop-save-3",
        bodyFallback:
          "Click a parent category row to expand or collapse its subcategories. This helps you see how your groups are arranged.",
        imageId: "category-tree"
      }
    ]
  },
  {
    id: "what-next",
    titleKey: "add-category-sop-next-title",
    titleFallback: "What to do next",
    steps: [
      {
        bodyKey: "add-category-sop-next-1",
        bodyFallback:
          "When you add a product, choose the category it belongs to. Every product needs a category."
      },
      {
        bodyKey: "add-category-sop-next-2",
        bodyFallback:
          "If you need a category while adding a product, you can also create one from the product form without leaving the page."
      }
    ]
  }
];
